<template>
  <transition name="fade">
    <div class="loadingWrap" v-if="!loadEnd">
      <div class="div">
        <!-- <img :src="loadingImg" class="loadingImg"/> -->
        <div class="birdWrap">
          <div id="sky">
            <div class="bird">
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="wind"></div>
              <div class="bird_body">
                <div class="bird_head"></div>
                <div class="bird_wing_left">
                  <div class="bird_wing_left_top"></div>
                </div>
                <div class="bird_wing_right">
                  <div class="bird_wing_right_top"></div>
                </div>
                <div class="bird_tail_left"></div>
                <div class="bird_tail_right"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="imgBox">
          <div class="imgWrap" :style="{width: percentage + '%'}"></div>
        </div>
        <p>LOADING {{percentage}}%</p>
      </div>
    </div>
  </transition>
</template>

<script>
import loadingImg from "@/assets/img/loading.gif"
import { reptilesShowList, JeholBiotaList } from '../content4/data.js'
import { featheredList } from '../content5/data.js'
import { confuciusornisShowList, sapeornithidaeList } from '../content6/data.js'
import { fengningensisList, cathayornithidaeList, longipteryxList, pengornithidaeList, otherList } from '../content7/data.js'
import { martiniList, gansusList } from '../content8/data.js'
const totalList = [...reptilesShowList, ...JeholBiotaList, ...featheredList, ...confuciusornisShowList, ...sapeornithidaeList, ...fengningensisList, ...cathayornithidaeList, ...longipteryxList, ...pengornithidaeList, ...otherList, ...martiniList, ...gansusList]

export default {
  props: {
    loadEnd: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loadingImg,
      totalList, // 所有数据
      nowLoad: 0, // 现在加载到第几张
    };
  },
  mounted () {
    this.loadAllImg()
  },
  computed: {
    percentage () { // 图片加载百分比
      let { totalList, nowLoad } = this
      if ( nowLoad == 0 ) {
        return 0
      }
      let nub = Math.floor(nowLoad / totalList.length * 100)
      nub = nub > 100 ? 100 : nub
      return nub
    },
  },
  methods: {
    loadAllImg () {
      let { totalList, nowLoad } = this
      let newImg = new Image();
      newImg.src = totalList[nowLoad].src
      newImg.onload = () => {
        nowLoad++
        if ( nowLoad > totalList.length - 1 ) {
          this.$emit('changeLoadState')
          return
        } else {
          this.nowLoad = nowLoad
          this.loadAllImg()
        } 
      }

    },
    
  },
};
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './bird.css'
@import './loading.styl'
</style>